import theme from '../../themes/theme';

const { pageBackground } = theme;

export default {
  layoutContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'center',
    alignContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  content: {
    background: pageBackground,
    display: 'flex',
    flexDirection: 'column',
    order: 0,
    flex: 9,
    alignSelf: 'stretch',
    padding: '0 1.5em 0 4em',
  },
};
